import { render, staticRenderFns } from "./ControlDrugAdmin.vue?vue&type=template&id=12ccbe98"
import script from "./ControlDrugAdmin.vue?vue&type=script&lang=js"
export * from "./ControlDrugAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports